import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import About from './pages/About';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import { BlogList, BlogPostDetail } from './pages/Articles';
import Footer from './components/Footer';
import { Analytics } from '@vercel/analytics/react';
import ScrollToTop from './components/ScrollToTop';
import CustomCursor from './components/CustomCursor';
import ScrollProgress from './components/ScrollProgress';
import { initGA, trackPageView } from './lib/analytics';

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <div className="font-sans bg-slate-900 text-slate-100 min-h-screen">
          <CustomCursor />
          <ScrollProgress />
          <GoogleAnalytics />
          <Header />
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:id" element={<BlogPostDetail />} />
          </Routes>
          <Footer />
          <Analytics />
        </div>
      </Router>
    </HelmetProvider>
  );
};

export default App;
